import { mapGetters } from "vuex";
import { find } from "lodash";

export default {
    name: "header-lesson-statistic",
    computed: {
        ...mapGetters({
            listStudents: "coursesWidgets/listStudents",
            lesson: "coursesLesson/lesson",
            module: "coursesLesson/module",
            loading: "coursesLesson/loading",
            user: "user/user",
        }),
        activeIndex() {
            if (!this.module || !this.lesson) return "...";
            return this.module.userModule.data.completedMaterials;
        },
        lessonCount() {
            if (!this.module || !this.lesson) return "...";
            return this.lesson.module.data.materialsCount;
        },
        progressPercent() {
            if (!this.module || !this.lesson) return "...";
            return Math.round(
                (this.activeIndex / this.lesson.module.data.materialsCount) * 100
            );
        },

        currentStudent() {
            let user = this.$store.state.user.user;

            if (!user) return {};
            return find(this.listStudents, ["id", user.id]);
        },
    },

    methods: {
        onMod() {
            console.log(this.module);
        },

        onBackHistory() {
            window.history.back();
        },

        declensionWord(count) {
            let titles = [this.$t("point1"), this.$t("point2"), this.$t("point3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[
                count % 100 > 4 && count % 100 < 20
                    ? 2
                    : cases[count % 10 < 5 ? count % 10 : 5]
            ];
        },
    },
};
